import { isContainedInList, defaultField } from "helpers/row-logic-helper";
import {
  LOAN_TYPES
  , HEDGE_TYPES
} from "@loanbossinc/component-library";
import { get } from "lodash";

export const shouldShowMaxCapStrike = loan => Boolean(get(loan, "hedgeRequirements.maxCapStrike")) &&
  isContainedInList(loan, "details.loanTypeId", [
    LOAN_TYPES.FREDDIE_MAC
  ]) &&
  isContainedInList(loan, "hedgeRequirements.requiredHedgeId", [
    HEDGE_TYPES.CAP
  ]);

export const shouldShowMaxCapStrikeEdit = loan => isContainedInList(loan, "details.loanTypeId", [
  LOAN_TYPES.FREDDIE_MAC
]) &&
  isContainedInList(loan, "hedgeRequirements.requiredHedgeId", [
    HEDGE_TYPES.CAP
  ]);

export const shouldShowPricingRequirements = loan => isContainedInList(loan, "details.loanTypeId", [
  LOAN_TYPES.CONSTRUCTION,
  LOAN_TYPES.OTHER_TYPE,
  LOAN_TYPES.CMBS,
  LOAN_TYPES.BALANCE_SHEET,
  LOAN_TYPES.BRIDGE,
  LOAN_TYPES.FANNIE_MAE,
  LOAN_TYPES.HUD,
  LOAN_TYPES.PREF_EQUITY,
  LOAN_TYPES.VALUE_ADD,
  LOAN_TYPES.LIFE_CO,
  LOAN_TYPES.MEZZ,
  LOAN_TYPES.LINE_OF_CREDIT
]);

export const shouldShowRequiredHedge = loan => Boolean(get(loan, "hedgeRequirements.requiredHedge.value"));

export const shouldShowNotional = loan => Boolean(get(loan, "hedgeRequirements.notional"));

export const shouldShowTermMonths = loan => Boolean(get(loan, "hedgeRequirements.termMonths"));

export const shouldShowRatingRequirements = loan => Boolean(get(loan, "hedgeRequirements.ratingsRequirements"));

export const shouldShowExtensions = loan => Boolean(get(loan, "hedgeRequirements.extensions"));

export const shouldShowCollateralAssignment = loan => Boolean(get(loan, "hedgeRequirements.collateralAssignment"));

export const shouldShowLegalOpinion = loan => Boolean(get(loan, "hedgeRequirements.legalOpinion"));

export const shouldShowExecutionRequirements = loan => Boolean(get(loan, "hedgeRequirements.executionRequirements"));

export const shouldShowMisc = loan => Boolean(get(loan, "hedgeRequirements.misc"));
